import { useEffect, useState } from "react";
import { navItems } from "@/mocks/dramaData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-[68px]">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl text-background-50 ${
              scrolled ? "bg-primary-500" : "bg-primary-500"
            }`}
          >
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span
            className={`font-brand text-2xl leading-none ${
              scrolled ? "text-foreground-950" : "text-foreground-950"
            }`}
          >
            本月大瓜
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-800 transition hover:bg-background-200/80 hover:text-primary-700 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 lg:flex">
          <a
            href="#contact"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            投稿吃瓜
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="菜单"
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-background-100 text-foreground-900 lg:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition hover:bg-background-200/80 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50"
            >
              投稿吃瓜 <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}